import { render, staticRenderFns } from "./ServerFilterPrependSlot.vue?vue&type=template&id=5ce68d56&scoped=true&"
import script from "./ServerFilterPrependSlot.vue?vue&type=script&lang=js&"
export * from "./ServerFilterPrependSlot.vue?vue&type=script&lang=js&"
import style0 from "./ServerFilterPrependSlot.vue?vue&type=style&index=0&id=5ce68d56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce68d56",
  null
  
)

export default component.exports
import {QIcon} from 'quasar'
component.options.components = Object.assign({QIcon}, component.options.components || {})
